

































































































































































































































import { Component, Vue, Emit, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { DateTime } from 'luxon'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskCPFCNPJ } from '@/utils/common'

@Component

export default class ComponentModalAtualizarNotaFiscal extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean

  $refs!: {
    formRules: any,
    dateA: any,
    documentos: any,
  }

  mensagemError: any = {
    dateText: '',
  }

  formRules: any = {
    valid: true,
    dataRecebimentoNota: [v => !!v || 'O campo data de recebimento da nota é obrigatório.'],
    numeroNota: [v => !!v || 'O campo número da nota é obrigatório.'],
    numeroContasPagar: [v => !!v || 'O campo número contas a pagar é obrigatório.'],
    comentario: [v => !!v || 'O campo comentário é obrigatório.'],
  }

  loadAnexo: boolean = false
  loadDeletar: boolean = false
  loadConfirmar: boolean = false
  motivo: any[] = []
  dateText: string = ''
  imageUrl: string = ''
  date: string = ''
  anexo: any = {}
  podeFazerUploadVal: boolean = true

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: boolean) {
    this.loadDeletar = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get isDisableConfirmar() {
    return this.getFinanceiroStore.disabledConfirmar
  }

  set isDisableConfirmar(value: boolean) {
    this.getFinanceiroStore.setDisabledConfirmar(value)
  }

  get podeFazerUpload() {
    return this.podeFazerUploadVal
  }

  set podeFazerUpload(value: boolean) {
    this.podeFazerUploadVal = value
  }

  set getMotivo(value: string[]) {
    const store = this.getFinanceiroStore

    if (!Array.isArray(store.prestadorRecebimento.notasFiscais)) {
      store.prestadorRecebimento.notasFiscais = []
    }

    if (store.prestadorRecebimento.notasFiscais.length === 0) {
      store.prestadorRecebimento.notasFiscais.push({
        createdByNome: '',
        createdOn: '',
        dataRecebimentoNota: '',
        descricaoDivergencia: '',
        divergencia: false,
        documentoId: '',
        motivo: [],
        nomeArquivoOriginal: '',
        notaCancelada: false,
        numeroContasPagar: '',
        numeroNota: '',
        prestadorRecebimentoId: '',
        situacao: '',
        valorNotaFiscal: 0,
        comentario: '',
      })
    }

    if (!Array.isArray(store.prestadorRecebimento.notasFiscais[0].motivo)) {
      store.prestadorRecebimento.notasFiscais[0].motivo = []
    }

    store.prestadorRecebimento.notasFiscais[0].motivo = [...value]
  }

  get getMotivo() {
    const { notasFiscais } = this.getFinanceiroStore.prestadorRecebimento

    if (!Array.isArray(notasFiscais) || notasFiscais.length === 0) {
      return []
    }

    return Array.isArray(notasFiscais[0].motivo) ? notasFiscais[0].motivo : []
  }

  get notaFiscalUnica() {
    return this.getFinanceiroStore.notaFiscalUnica || {}
  }

  set loadingAnexo(value: boolean) {
    this.loadAnexo = value
  }

  get loadingAnexo() {
    return this.loadAnexo
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get showModalAtualizarNotaFiscal() {
    return this.getFinanceiroStore.modal.atualizarNotaFiscal
  }

  set showModalAtualizarNotaFiscal(value: boolean) {
    this.getFinanceiroStore.setModal({ name: 'atualizarNotaFiscal', value })
  }

  get prestadorRecebimento() {
    return this.getFinanceiroStore.prestadorRecebimento
  }

  get getDateText1() {
    this.dateText = this.formatISOToDate(this.date)
    return this.dateText
  }

  set getDateText1(value: string | Date) {
    this.dateText = this.formatISOToDate(this.date)
  }

  get anexoNotaFiscal() {
    return this.anexo
  }

  set anexoNotaFiscal(value: any) {
    this.anexo = value
  }

  formatISOToDate(value: string | Date) {
    if (value === '' || !value) return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT)
  }

  clickDateTime(event) {
    if (!this.date) {
      this.date = moment(new Date()).format('YYYY-MM-DD')
    }

    this.$refs.dateA.open(event)
  }

  async confirmar() {
    this.loadingConfirmar = true
    const { files } = this.$refs.documentos.$refs.upload
    if (this.$refs.formRules.validate()) {
      // Valida se há um novo arquivo ou mantém o nome do arquivo original
      if (!this.notaFiscalUnica.divergencia && files.length < 1 && this.notaFiscalUnica.nomeArquivoOriginal === '') {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar uma nota fiscal', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      // Passo 1: Upload do arquivo apenas se houver um novo documento
      let notaFiscalUrl = this.notaFiscalUnica.notaFiscalUrl || ''
      if (files.length > 0 && this.podeFazerUpload) {
        const params: any = {
          documentoId: this.getFinanceiroStore.documentoId,
          prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
          formData: this.anexoNotaFiscal.formData,
        }
        const step1 = await this.getFinanceiroStore.uploadNotaFiscalUnica(params)
        if (!step1.success) {
          EventBus.$emit('setSnackbar', { show: true, text: step1.message || 'Houve um problema ao enviar nota fiscal', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
        notaFiscalUrl = step1.data.url
      }

      const params: any = {
        prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
        motivo: this.getMotivo.length > 0 ? this.getMotivo : ['Nenhum'],
        divergencia: this.notaFiscalUnica.divergencia,
        notaFiscalUrl,
        numeroNota: this.notaFiscalUnica.numeroNota,
        numeroContasPagar: this.notaFiscalUnica.numeroContasPagar,
        comentario: this.notaFiscalUnica.comentario,
        valorNotaFiscal: this.getFinanceiroStore.prestadorRecebimento.valorRepasse,
      }

      if (this.isValid()) {
        params.dataRecebimentoNota = this.date
      }

      const response = await this.getFinanceiroStore.atualizarRecebimetno(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal atualizada com sucesso', icon: 'done', color: '#2E7D32' })
        this.getFinanceiroStore.atualizarAcaoPodeProvisionar(this.getFinanceiroStore.prestadorRecebimento.id)
        await this.getFinanceiroStore.getPrestadorRemuneracaoAll()
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na atualização da nota fiscal', icon: 'warning', color: '#C62828' })
      }
    }
    this.loadingConfirmar = false
    return files
  }

  async deletar() {
    this.loadingDeletar = true
    const params: any = {
      documentoId: this.prestadorRecebimento.notasFiscais[0].documentoId,
      prestadorRecebimentoId: this.prestadorRecebimento.id,
    }
    const response = await this.getFinanceiroStore.deletarDocumento(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal deletada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.notaFiscalUnica.nomeArquivoOriginal = ''
      this.isDisableConfirmar = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao deletar nota fiscal.', icon: 'warning', color: '#C62828' })
    }

    this.loadingDeletar = false
  }

  clearDate() {
    if (this.getFinanceiroStore.prestadorRecebimento.notasFiscais) {
      this.getFinanceiroStore.prestadorRecebimento.notasFiscais[0].dataRecebimentoNota = ''
    }
  }

  async inputFile(newFile, oldFile) {
    this.loadingAnexo = true

    if (newFile.identifier) {
      return
    }

    const formData = new FormData()
    formData.append('notaFiscal', newFile.file)

    const params: any = {
      formData,
      documentoId: this.getFinanceiroStore.documentoId,
      prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
    }

    this.notaFiscalUnica.nomeArquivoOriginal = newFile.name
    this.anexoNotaFiscal = params
    this.isDisableConfirmar = true
    this.podeFazerUpload = true
    EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal enviada com sucesso.', icon: 'done', color: '#2E7D32' })

    this.loadingAnexo = false
  }

  async download(prestadorRecebimentoId: string) {
    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId })
    const win = window.open()
    // @ts-ignore
    win.document.body.style.margin = '0'
    // @ts-ignore
    win.document.body.style.padding = '0'
    // @ts-ignore
    win.document.write(`<iframe src="${response.data}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin:-8px;" allowfullscreen></iframe>`)
  }

  async closeModal() {
    this.showModalAtualizarNotaFiscal = false
    this.$refs.formRules.reset()
    this.isDisableConfirmar = false
    this.podeFazerUpload = false
    EventBus.$emit('changeModoVisualizacao', false)
  }

  isValid() {
    this.mensagemError.dateText = ''

    if (!this.date) {
      this.mensagemError.dateText = 'O campo data de recebimento da nota é obrigatório.'
      return false
    }

    return true
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  @Watch('date')
  onDateChange(value: string) {
    this.dateText = this.formatISOToDate(value)
  }

  @Watch('showModalAtualizarNotaFiscal')
  onShowModalAtualizarNotaFiscalChange(value: boolean) {
    if (value) {
      const nota = this.getFinanceiroStore.prestadorRecebimento.notasFiscais[0]
      this.date = nota ? nota.dataRecebimentoNota : ''
      this.dateText = this.formatISOToDate(this.date)
    }
    if (this.notaFiscalUnica.nomeArquivoOriginal) {
      this.isDisableConfirmar = true
    }
  }
}
